import React from "react";
import "./DashNavigation.css";
import navLogo from "../../../assets/profits.svg";
import { AiFillHome, AiOutlineLogout } from "react-icons/ai";
import { FiSettings } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { MdHistory } from "react-icons/md";
import { FaCreditCard } from "react-icons/fa";
import { FiTrendingUp } from "react-icons/fi";

const DashNavigation = ({ pathname }) => {
  const navigate = useNavigate();
  const isInvestmentActive =
    pathname === "/investments" || pathname === "/markets";
  return (
    <>
      <section className="dash_navigation_sect">
        <div className="navigation_logo">
          <img src={navLogo} alt="" />
        </div>
        <div className="dashboard_navigation_links">
          <div onClick={() => navigate("/wallet")}>
            <AiFillHome
              color={pathname === "/wallet" ? "#162af1" : "#1464b8"}
              size={22}
            />
            <p
              style={{
                color: `${pathname === "/wallet" ? "#162af1" : "#1464b8"}`,
              }}
            >
              Home
            </p>
          </div>
          <Link
            to="/investments"
            aria-current={isInvestmentActive ? "page" : undefined}
          >
            <FiTrendingUp
              color={isInvestmentActive ? "#162af1" : "#1464b8"}
              size={22}
            />
            <p
              style={{
                color: isInvestmentActive ? "#162af1" : "#1464b8",
              }}
            >
              Investments
            </p>
          </Link>
          <div onClick={() => navigate("/get-card")}>
            <FaCreditCard
              color={pathname === "/get-card" ? "#162af1" : "#1464b8"}
              size={22}
            />
            <p
              style={{
                color: `${pathname === "/get-card" ? "#162af1" : "#1464b8"}`,
              }}
            >
              Card
            </p>
          </div>
          <div onClick={() => navigate("/settings")}>
            <FiSettings
              color={pathname === "/settings" ? "#162af1" : "#1464b8"}
              size={22}
            />
            <p
              style={{
                color: `${pathname === "/settings" ? "#162af1" : "#1464b8"}`,
              }}
            >
              User
            </p>
          </div>
        </div>
        <div
          className="logout_sect"
          onClick={() => {
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("token");
            navigate("/auth/login", { replace: true });
          }}
        >
          <AiOutlineLogout color={"#1464b8"} size={22} />
          <p style={{ color: "#1464b8" }}>Logout</p>
        </div>
      </section>
      <section className="mobile_dashboard">
        <div onClick={() => navigate("/wallet")}>
          <AiFillHome
            color={pathname === "/wallet" ? "#162af1" : "#1464b8"}
            size={22}
          />
          <p
            style={{
              fontSize: 12,
              color: `${pathname === "/wallet" ? "#162af1" : "#1464b8"}`,
            }}
          >
            Home
          </p>
        </div>
        <Link
          to="/investments"
          aria-current={isInvestmentActive ? "page" : undefined}
        >
          <FiTrendingUp
            color={isInvestmentActive ? "#162af1" : "#1464b8"}
            size={20}
          />
          <p
            style={{
              fontSize: 12,
              color: isInvestmentActive ? "#162af1" : "#1464b8",
            }}
          >
            Invest
          </p>
        </Link>

        <div onClick={() => navigate("/transactions")}>
          <MdHistory
            color={pathname === "/transactions" ? "#162af1" : "#1464b8"}
            size={20}
          />
          <p
            style={{
              fontSize: 12,
              color: `${pathname === "/transactions" ? "#162af1" : "#1464b8"}`,
            }}
          >
            Transactions
          </p>
        </div>
        <div onClick={() => navigate("/get-card")}>
          <FaCreditCard
            color={pathname === "/get-card" ? "#162af1" : "#1464b8"}
            size={20}
          />
          <p
            style={{
              fontSize: 12,
              color: `${pathname === "/get-card" ? "#162af1" : "#1464b8"}`,
            }}
          >
            Card
          </p>
        </div>
        <div onClick={() => navigate("/settings")}>
          <FiSettings
            color={pathname === "/settings" ? "#162af1" : "#1464b8"}
            size={22}
          />
          <p
            style={{
              fontSize: 12,
              color: `${pathname === "/settings" ? "#162af1" : "#1464b8"}`,
            }}
          >
            Profile
          </p>
        </div>
        <div
          className="logout_sect"
          onClick={() => {
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("token");
            navigate("/auth/login", { replace: true });
          }}
        >
          <AiOutlineLogout color={"#1464b8"} size={22} />
          <p style={{ color: "#1464b8" }}>Logout</p>
        </div>
      </section>
    </>
  );
};

export default DashNavigation;
